import React, {Component} from 'react';
import LearningHistory from "./index";

class LearningHistoryManagement extends Component {

  static PATH = "learning-history";

  render() {
    return <LearningHistory/>;
  }
}

export default LearningHistoryManagement;